import PropTypes from 'prop-types';
import _ from 'lodash';

const errorStyles = {
  position: 'absolute',
  color: '#f44336',
  fontSize: '12px',
  fontWeight: '600',
  letterSpacing: '0.1px',
  bottom: '0px',
};

function RadioButton({
  value = null,
  onChange,
  options,
  label = undefined,
  required = false,
  error = undefined,
  name = undefined,
}) {
  const className = required ? 'onboarding-label-required' : 'onboarding-label';

  return (
    <div className="radio-button-group">
      {label && <p className={className}>{label}</p>}
      {_.map(options, (option, i) => (
        <label key={i}>
          <input
            type="radio"
            name={name} // important for grouping
            value={option.value}
            checked={value?.toString() === option.value.toString()}
            onChange={() => onChange(option.value)}
          />
          <span />
          <p>{option.label}</p>
        </label>
      ))}
      {error && <p style={errorStyles}>{error}</p>}
    </div>
  );
}

RadioButton.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string, // RHF will pass this down
};

export default RadioButton;
